import Vue from 'vue';

export function CustomHistoryModel () {
    this.agencyName = null;
    this.barcode = null;
    this.categoryId = null;
    this.expireDate = null;
    this.expireIn = null;
    this.extension = null;
    this.fullImageUrl = null;
    this.id = null;
    this.info1 = null;
    this.info2 = null;
    this.info3 = null;
    this.info4 = null;
    this.info5 = null;
    this.isAvailable = true;
    this.isClickable = true;
    this.isDrawAnnounce = false;
    this.isDrawWinner = false;
    this.isMinPrivilegeMatch = false;
    this.itemNumber = null;
    this.minutesValidAfterUsed = null;
    this.name =  null;
    this.privilegeMessage = null;
    this.privilegeMessageFormat = null;
    this.redeemDate = null;
    this.redeemKey =  null;
    this.serial = null;
    this.status = null;
    this.type =  null;
    this.website = null;

    this.setDataFromApi = function (dict) {
        this.agencyName = dict.AgencyName;
        this.barcode = dict.Barcode;
        this.categoryId = dict.CategoryID;
        this.expireDate = dict.VoucherExpireDate;
        this.expireIn = dict.ExpireIn;
        this.extension = dict.Extension;
        this.fullImageUrl = dict.FullImageUrl;
        this.id = dict.ID;
        this.info1 = dict.Info1;
        this.info2 = dict.Info2;
        this.info3 = dict.Info3;
        this.info4 = dict.Info4;
        this.info5 = dict.Info5;

        if (dict.Extension) {
            switch(dict.Extension.Group) {
                case '1':
                case '2':
                case '3':
                case '9':
                    if (!dict.Extension.Used ) {
                        this.status = 'used';
                    } else {
                        this.isAvailable = false;
                        this.status = 'used';
                    }

                    if (dict.Extension.Cancel) {
                        this.isAvailable = false;
                        this.status = 'cancelled';
                    }

                    break;
                case '4':
                    if (!dict.Extension.Info) {
                        this.status = 'refill';
                    } else {
                        this.isAvailable = false;
                        this.isClickable = false;
                        this.status = 'refill';
                    }

                    break;
                case '5':
                case '6':
                    if (dict.Extension.Used) {
                        this.status = 'used';
                        if(dict.Serial == 'XXXXXXX'){
                            this.isAvailable = false;
                        }
                    }else{
                        if(dict.Serial == 'XXXXXXX'){
                            this.isAvailable = false;
                            this.status = 'expired';
                        }
                    }
                    break;
                default:
                    if (dict.Type == Vue.CampaignType.Draw) {
                        this.isAvailable = dict.HasWinner;
                        this.isClickable = false;
                        this.status = 'draw';

                    } else if (dict.Serial == 'XXXXXXX') {
                        this.isAvailable = false;
                        this.status = 'expired';
                    }

                    break;
            }
        } else {
            if (dict.Serial == 'XXXXXXX') {
                this.isAvailable = false;
                this.status = 'expired';
            }
        }

        this.isDrawAnnounce = dict.HasWinner;
        this.isDrawWinner = dict.IsWinner;
        this.isMinPrivilegeMatch = dict.IsMinPrivilegeMatch;
        this.itemNumber = dict.ItemNumber;
        this.minutesValidAfterUsed = dict.MinutesValidAfterUsed;
        this.name = dict.Name;
        this.privilegeMessage = dict.PrivilegeMessage;
        this.privilegeMessageFormat = dict.PrivilegeMessageFormat;
        this.redeemDate = dict.RedeemDate;
        this.redeemKey = dict.RedeemKey;
        this.serial = dict.Serial;
        this.type = dict.Type;
        this.website = dict.Website;
    };

    this.setDataFromApiRedeem = function (dict) {
        this.serial = dict.Serial;
        this.expireIn = dict.ExpireIn;
        this.itemNumber = dict.ItemNumber;
        this.privilegeMessage = dict.PrivilegeMessage;
        this.privilegeMessageFormat = dict.PrivilegeMessageFormat;
    };
}
